export default {
    sendTestmail: 'Testmail senden',
    sendTestmailDescription: 'Eine Testmail an die eigene E-Mail-Adresse senden',
    email: 'E-Mailadresse',

    sendTestmailSuccess: 'Die Testmail wurde erfolgreich versendet.',
    sendTestmailError: 'Beim Versenden der Testmail ist ein Fehler aufgetreten.',
}